import { render, staticRenderFns } from "./PortfolioPanel.vue?vue&type=template&id=71c10fde&scoped=true&"
import script from "./PortfolioPanel.vue?vue&type=script&lang=js&"
export * from "./PortfolioPanel.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioPanel.vue?vue&type=style&index=0&id=71c10fde&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c10fde",
  null
  
)

export default component.exports